export default __webpack_public_path__ + "static/media/client.d049b478.png";